import {getSimulation} from '../api/api';


export const REQUEST_SIMULATION = 'REQUEST_SIMULATION';
export const FETCH_SIMULATION_SUCCESS = 'FETCH_SIMULATION_SUCCESS';
export const FETCH_SIMULATION_FAILURE = 'FETCH_SIMULATION_FAILURE';


const _requestFetchSimulation = applicationType => {
    return {
        type: REQUEST_SIMULATION,
        applicationType
    };
};

export const fetchSimulationSuccess = simulation => {
    return {
        type: FETCH_SIMULATION_SUCCESS,
        simulation
    };
};

export const fetchSimulationFailure = error => {
    return {
        type: FETCH_SIMULATION_FAILURE,
        error
    };
};



export const fetchSimulation = (paymentAmount, cardType, paymentCurrency) => {
    return dispatch => {
        dispatch(_requestFetchSimulation());
        return getSimulation(paymentAmount, cardType, paymentCurrency)
            .then(simulation => dispatch(fetchSimulationSuccess(simulation)))
            .catch(error => dispatch(fetchSimulationFailure(error)));
    };
};
